import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import { Consumer } from '../../../global-variables-provider/GlobalVariablesProvider';
import * as Styled from './Style';
const {
  I18n
} = global;
const SegmentCarrier = ({
  carrierName,
  busModel,
  carrierAddressLeg,
  carrierEgrulEgis,
  carrierOgrn,
  carrierLegalName
}) => /*#__PURE__*/React.createElement(Styled.ListUnstyled, null, /*#__PURE__*/React.createElement(Styled.Title, null, carrierName ? I18n.t('components.Segment.carrier') : I18n.t('components.Segment.bus'), /*#__PURE__*/React.createElement(Tooltip, {
  className: "d-inline-block pointer",
  content: I18n.t('components.Segment.bus_attention'),
  placement: "top"
}, /*#__PURE__*/React.createElement("i", {
  className: "icon icon-info text-primary pointer"
}))), carrierName && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_name'), /*#__PURE__*/React.createElement("strong", null, carrierName)), busModel && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.model_bus_title'), ":", ' ', /*#__PURE__*/React.createElement("strong", null, busModel)), carrierLegalName && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_legal_name'), /*#__PURE__*/React.createElement("strong", null, carrierLegalName)), carrierAddressLeg && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_legal_address'), /*#__PURE__*/React.createElement("strong", null, carrierAddressLeg)), carrierEgrulEgis && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_egrul_egis'), /*#__PURE__*/React.createElement("strong", null, carrierEgrulEgis)), carrierOgrn && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_ogrn'), /*#__PURE__*/React.createElement("strong", null, carrierOgrn)), /*#__PURE__*/React.createElement(Consumer, null, ({
  isRu,
  isWlRu
}) => (isRu || isWlRu) && /*#__PURE__*/React.createElement("p", null, I18n.t('pages.search.trip.tabs.carrier.carrier_schedule'))));
SegmentCarrier.propTypes = {
  carrierName: PropTypes.string,
  busModel: PropTypes.string,
  carrierAddressLeg: PropTypes.string,
  carrierEgrulEgis: PropTypes.string,
  carrierOgrn: PropTypes.string,
  carrierLegalName: PropTypes.string
};
export default SegmentCarrier;